module.exports = "<form class=\"store-form\" name=\"storeForm\"\r\n      \r\n      autocomplete=\"off\"\r\n      novalidate>\r\n  <div class=\"error-text\" ng-bind=\"storeForm.error.message\"></div>\r\n <label>ZipCode<span><br>\r\n    <input name=\"zipcode\"\r\n           type=\"text\"\r\n           class=\"form-control\"\r\n           ng-model=\"store.zipcode\"\r\n           required>\r\n  <br>\r\n\r\n  <button type=\"button\"\r\n          class=\"btn btn-primary btn-block btn-sm-text mockup-btn\"\r\n          >\r\n    <span>Search Store</span>\r\n  </button>\r\n\r\n</form>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/store-selector/store-selector.html
// module id = 293
// module chunks = 0